import {getElement, removeActive} from "../modules/helpers.js";
import catalogItem from "../catalogItem/catalogItem.js";
import {filterElement} from "../modules/elements.js";
import {findVariationInProducts} from "../productPage/productItem.js";


export default function filterEvents() {
    const filterItems = getElement('[data-filter]', true);
    let noFilters = getElement('[data-filter]', true).length ? false : true;
    let filteredOnPage = getElement('[data-products-count]');
    const catalog = getElement('.catalog-page__items');
    if (!getElement('.filter__item ', true).length) {
        filterElement.style.border = 'none';
    }
    const filterSelected = filterElement.querySelector('.filter__selected');
    let filterObject = {};
    const currency = filterElement.dataset.currentCurrency;
    let filtered = [];
    let inStock = false;
    const productsArray = !isFiltered ? productsFromLoop : allProductsInCategory;
    const sortBtns = getElement('[data-sort]', true);
    let {pathname, origin, search} = location;
    if (isFiltered) {
        if (!search) {
            let pathArray = pathname.split('/').filter(item => {
                if (item) {
                    return item;
                }
            });
            pathArray.pop();
            pathArray.join('/');
            pathname = pathArray.join('/');
        }

    }
    history.pushState({pathname}, null, null)
    let url = origin + pathname;
    filterObject.sort = [];
    filterObject.inStock = inStock;
    filteredProductsCount(filterItems, filterObject);
    filterItems.forEach(filterItem => {
        if (filterItem.dataset.filter) {
            filterObject[filterItem.dataset.filter] = [];
            if (isFiltered) {
                Object.keys(filterObject).forEach(key => {
                    if (initQs[key]) {
                        let filterAttributes = initQs[key].split(',')
                        filterObject[key] = filterAttributes;
                        if (key == 'price_min' || key == 'price_max') {
                            getElement(`[data-filter='${key}']`).value = initQs[key];

                        }
                        if (key.match('pa') || key == 'product_tag') {
                            getElement(`[data-filter='${key}']`).classList.add('selected');
                            filterAttributes.forEach(item => {
                                const filterElement = getElement(`[data-filter='${key}']`).querySelector(`[data-filter-control="${item}"]`)
                                if (filterElement.classList.contains('checkbox')) filterElement.classList.add('active')
                                filterElement.classList.add('selected')
                            })
                        }


                    }
                })
            }
        }
        const filterControls = filterItem.querySelectorAll('[data-filter-control]');
        filterControls.forEach(control => {
            control.addEventListener('click', () => {
                if (!noFilters) {
                    noFilters = true;
                }
                const info = isLogin ? control.offsetParent.previousElementSibling.querySelector('.info') : null;
                control.classList.toggle('selected');
                if (control.classList.contains('selected')) {
                    filterItem.classList.add('selected');
                    if (!filterObject[filterItem.dataset.filter].includes(control.dataset.filterControl)) {
                        filterObject[filterItem.dataset.filter] = [...filterObject[filterItem.dataset.filter], control.dataset.filterControl]
                    }
                    if (!filterSelected.classList.contains('active')) {
                        filterSelected.classList.add('active')
                    }
                    if (isLogin) {
                        if (info && !info.querySelector('.label')) {
                            info.innerHTML = `<div class="label label--black">Update</div>`
                        }
                    }

                } else {
                    if (!Array.from(filterControls).find(element => element.classList.contains('selected'))) filterItem.classList.remove('selected');
                    filterObject[filterItem.dataset.filter] = filterObject[filterItem.dataset.filter].filter(el => el !== control.dataset.filterControl);
                    if (isLogin) {

                        if (info && !info.querySelector('.icon') && filterObject[filterItem.dataset.filter].length < 1) {
                            info.innerHTML = `<div class="mr-5">Default</div>
                                    <svg class="icon">
                                        <use xlink:href="#info"></use>
                                    </svg>`
                        }
                    }
                }
                if (noFiltered()) {
                    filtered = filteredProducts(filterObject);
                    renderFilterProducts(filtered);
                    filteredProductsCount(filterItems, filterObject, control);
                } else {
                    history.replaceState({pathname}, document.title, url)
                    renderAllProducts();
                    filteredProductsCount(filterItems, filterObject, control)
                }
                filterLabels()

            })
        })
        if (screen.width < 1023) {
            if (filterItem.parentElement.previousElementSibling) {
                filterItem.parentElement.previousElementSibling.addEventListener('click', function () {
                    if (filterItem.querySelectorAll('.focus').length && this.parentElement.classList.contains('focus')) {
                        this.parentElement.classList.remove('focus')
                        filterItem.querySelectorAll('.focus').forEach(focus => {
                            focus.classList.remove('focus')
                        })
                    }

                })
            }

            filterItem.querySelectorAll('.dropdown').forEach(dropdown => {
                dropdown.addEventListener('click', (e) => {
                    // if (screen.width < 1023){
                    if (dropdown.closest('.filter__item')) {
                        dropdown.closest('.filter__item').classList.toggle('focus')
                        dropdown.closest('.dropdown').classList.toggle('focus')

                    }
                    // }

                })
            })
        }
    })

    if (isFiltered) {
        if (initQs._stock_status) {
            filterObject.inStock = true;
            inStock = true;
        }
        if (initQs.order) {
            filterObject.sort = initQs.order;
            removeActive(sortBtns, 'disabled');
            getElement(`[data-sort="${initQs.order}"]`, true).forEach(sortBtn => {
                sortBtn.classList.add('disabled')
                sortBtn.closest('.dropdown').querySelector('[data-sort-by]').innerText = sortBtn.innerHTML;
                sortBtn.closest('.dropdown').querySelector('[data-sort-by]').dataset.sortBy = sortBtn.dataset.sort;
            })

        }
        renderFilterProducts(filteredProducts(filterObject));
        // catalogItem(filteredProducts(filterObject));
        filteredProductsCount(filterItems, filterObject, {});
        filterLabels()
    }
    let priceValues = [];
    getElement('[data-filter-stock]', true).forEach(stockBtn => {
        if (inStock) stockBtn.classList.add('active');
        stockBtn.addEventListener('click', function () {
            inStock = !inStock;
            filterObject.inStock = inStock;
            renderFilterProducts(filteredProducts(filterObject));
            filterSelected.querySelectorAll('button').forEach(btn => {
                if (btn.dataset.filterBtn == 'clear' && btn.classList.contains('disabled')) btn.classList.remove('disabled')
            })
            filteredProductsCount(filterItems, filterObject, this);
        })
    })
    getElement('[data-price]', true).forEach(priceItem => {
        let dataAtr = priceItem.id;
        filterElement.querySelectorAll(`[data-price-${dataAtr}]`).forEach(priceBtn => {
            if (!priceValues.includes(priceBtn.getAttribute(`data-price-${dataAtr}`))) {
                priceValues = [...priceValues, priceBtn.getAttribute(`data-price-${dataAtr}`)]
            }
            priceBtn.addEventListener('click', () => {

                priceItem.value = priceBtn.getAttribute(`data-price-${dataAtr}`);
                if (!priceItem.parentElement.classList.contains('not-empty')) priceItem.parentElement.classList.add('not-empty');
                getElement('[data-price]', true).forEach(input => {
                    if (input.parentElement.classList.contains('not-empty')) {
                        filterObject[input.id] = [input.value];
                    }

                })


                if (priceItem.closest('.filter__items').querySelectorAll('.not-empty').length == getElement('[data-price]', true).length) {

                    priceItem.closest('.filter__items').dataset.priceAll = true;
                } else {
                    priceItem.closest('.filter__items').dataset.priceAll = false;
                }

                // if (priceItem.closest('.dropdown')) priceItem.closest('.dropdown').classList.toggle('focus')
                renderFilterProducts(filteredProducts(filterObject));
                filteredProductsCount(filterItems, filterObject, priceBtn);
                filterLabels()
                // return
            })

        })
        priceItem.addEventListener('keydown', (e) => {


            if (e.keyCode == 13) {
                if (priceItem.value) {
                    filterObject[priceItem.id] = [priceItem.value];
                } else {
                    filterObject[priceItem.id] = [];
                }
                renderFilterProducts(filteredProducts(filterObject));
                filteredProductsCount(filterItems, filterObject, priceItem);
                filterLabels()


            }

        })

        // priceItem.addEventListener('blur', () => {
        //     if (priceItem.value) {
        //         filterObject[priceItem.id] = [priceItem.value];
        //
        //     } else {
        //         filterObject[priceItem.id] = [];
        //     }
        //     renderFilterProducts(filteredProducts(filterObject));
        //     filteredProductsCount(filterItems, filterObject, priceItem);
        //     filterLabels()
        //
        //
        // })


    })
    getElement('[data-filter-btn]', true).forEach(filterBtn => {
        filterBtn.addEventListener('click', () => {
            if (filterBtn.dataset.filterBtn == 'clear') {
                for (let key in filterObject) {
                    filterObject[key] = [];
                }
                if (!filterBtn.classList.contains('disabled')) filterBtn.classList.add('disabled')
                filterElement.querySelector('.filter__selected').querySelector('.labels').innerHTML = '';
                removeActive(getElement('[data-filter-control]', true), 'selected');
                removeActive(getElement('[data-filter]', true), 'selected');
                removeActive(filterElement.querySelectorAll('.form__item'), 'not-empty');
                getElement('[data-price]', true).forEach(input => {
                    input.value = null;
                })
                if (isLogin) {

                    filterElement.querySelectorAll('.info').forEach(info => {
                        info.innerHTML = `<div class="mr-5">Default</div>
                                    <svg class="icon">
                                        <use xlink:href="#info"></use>
                                    </svg>`
                    })
                }
                removeActive(filterElement.querySelectorAll('.checkbox'));
                filterObject.inStock = false;
                getElement('[data-filter-stock]', true).forEach(stockBtn => {
                    inStock = false;
                    if (stockBtn.classList.contains('active')) stockBtn.classList.remove('active')
                })
                filterSelected.classList.remove('active')
                removeActive(sortBtns, 'disabled');
                getElement('[data-sort="normal"]', true).forEach(sortBtn => {
                    sortBtn.classList.add('disabled')
                    sortBtn.closest('.dropdown').querySelector('[data-sort-by]').innerText = sortBtn.innerHTML;
                    sortBtn.closest('.dropdown').querySelector('[data-sort-by]').dataset.sortBy = sortBtn.dataset.sort;
                })
                renderAllProducts();
                filteredProductsCount(filterItems, filterObject);
                history.replaceState({pathname}, document.title, url)

            } else {
                if (document.body.classList.contains("active")) document.body.classList.toggle("active");
                filterElement.classList.toggle('close')
                filterElement.classList.toggle("open");
                filterElement.parentElement.classList.toggle("open");
            }


        })
    })
    sortBtns.forEach(sortBtn => {
        sortBtn.addEventListener('click', () => {
            if (sortBtn.closest('.dropdown').classList.contains('active')) {
                sortBtn.closest('.dropdown').classList.remove('active')
            }
            if (matchMedia("(min-width: 320px)" && "(max-width: 767px)").matches) {
                document.body.classList.toggle('active');
            }
            removeActive(sortBtns, 'disabled');
            sortBtn.classList.add('disabled')
            sortBtn.closest('.dropdown').querySelector('[data-sort-by]').innerText = sortBtn.innerHTML;
            sortBtn.closest('.dropdown').querySelector('[data-sort-by]').dataset.sortBy = sortBtn.dataset.sort;
            filterObject.sort = sortBtn.closest('.dropdown').querySelector('[data-sort-by]').dataset.sortBy != 'normal' ? sortBtn.closest('.dropdown').querySelector('[data-sort-by]').dataset.sortBy : [];
            renderFilterProducts(filteredProducts(filterObject));
            // filteredProductsCount(filterItems, filterObject, this);
        })

    })

    function noFiltered() {
        if (!filterElement.querySelectorAll('[data-filter-control].selected').length && !filterElement.querySelectorAll('.not-empty').length) {
            filterSelected.classList.remove('active')
            filterSelected.querySelectorAll('button').forEach(btn => {
                if (btn.dataset.filterBtn == 'clear') btn.classList.add('disabled');
            })
        }
        ;
        if (!filterObject.sort.length && !filterObject.inStock && !filterElement.querySelectorAll('[data-filter-control].selected').length && !filterElement.querySelectorAll('.not-empty').length) {
            return false;
        }
        return true;
    }

    function createFilterUrl(filterObject) {

        // let single
        let isSingle = filterObject.inStock ? 1 : 0;
        // console.log(isSingle, filterObject)
        Object.keys(filterObject).forEach(key => {

            if (key !== 'inStock' && filterObject[key].length) {

                return isSingle += filterObject[key].length;
            }

        })


        if (isSingle == 1) {
            let attr = ''
            Object.keys(filterObject).forEach(key => {
                if (key !== 'sort' && filterObject[key].length) {
                    if (key == 'price_min' || key == 'price_max') {
                        return attr = `?${key + '=' + filterObject[key][0]}`
                    }
                    return attr = `${filterObject[key][0]}/`;
                }
            })
            // if (filterObject.sort && filterObject.sort.length) {
            //     attr += `?order=${filterObject.sort}`
            // }
            if (filterObject.inStock) {
                attr = `?_stock_status=instock`
            }

            // console.log(attr, filterObject.sort)

            history.replaceState({pathname}, document.title, `${pathname + attr}`);

        } else {
            let attr = ''

            Object.keys(filterObject).forEach(key => {
                if (key !== 'sort' && filterObject[key].length) {
                    if (key == 'product_tag') {
                        attr += `product_tag=${filterObject[key].join(',')}&`;
                    } else {
                        attr += `${key + "=" + filterObject[key].join(',')}&`;
                    }
                }
                if (key == 'inStock' && filterObject.inStock) {
                    attr += `_stock_status=instock&`
                }
                if (key == 'sort' && filterObject.sort.length) {
                    attr += `order=${filterObject.sort}&`

                }
            })
            if (attr) {
                history.replaceState({pathname}, document.title, `${pathname + "?" + attr.slice(0, -1)}`);
            } else {
                history.replaceState({pathname}, document.title, `${pathname + attr.slice(0, -1)}`);
            }

        }


    }

    function renderFilterProducts(filtered) {
        createFilterUrl(filterObject)
        catalog.querySelectorAll('.catalog-item').forEach(catalogItem => catalogItem.remove());
        if (catalog.querySelector('.no-products')) catalog.querySelector('.no-products').remove()
        if (filtered && filtered.length) {
            catalog.insertAdjacentHTML('afterbegin', renderProducts(filtered));
            catalogItem(filtered, filterObject);

        } else {
            if (!catalog.firstElementChild.classList.contains('no-products')) catalog.insertAdjacentHTML('afterbegin', '<div class="no-products">No products find</div>');
            ;

        }
        filteredOnPage.innerText = filtered.length
    }

    function renderAllProducts() {
        catalog.querySelectorAll('.catalog-item').forEach(catalogItem => catalogItem.remove());
        catalog.insertAdjacentHTML('afterbegin', renderProducts(productsArray));
        catalogItem(productsArray);
        filteredOnPage.innerText = productsArray.length
    }


    //FILTER LABELS FUNCTIONS
    function filterLabels() {
        filterSelected.querySelectorAll('button').forEach(btn => {
            if (btn.dataset.filterBtn == 'clear' && btn.classList.contains('disabled')) btn.classList.remove('disabled')
        })
        filterSelected.querySelector('.labels').innerHTML = renderFilterLabels();

        if (filterElement.querySelector('.filter__selected').querySelectorAll('.label').length) filterElement.querySelector('.filter__selected').classList.add('active')
        labelEvents();

    }

    function renderFilterLabels() {
        let labels = ''
        let price = ''
        for (let key in filterObject) {
            if (key !== 'sort' && filterObject[key].length) {
                filterObject[key].forEach(value => {

                        if (key.match('pa') || key == 'product_tag') {
                            let name = getElement(`[data-filter-control="${value}"]`).querySelector('.h3').firstElementChild.innerText;
                            return labels += `<div class="label">
                            <div class="mr-5">${name}</div>
                            <span class="delete" data-delete="${key}/${value}"><svg class="icon"> <use xlink:href="#close"></use> </svg></span></div>`
                        }
                        if (+filterObject.price_min && +filterObject.price_max) {
                            price = `<div class="label">
                            <div class="mr-5">From ${currency + filterObject.price_min} to ${currency + filterObject.price_max}</div>
                            <span class="delete" data-delete="from-to"><svg class="icon"> <use xlink:href="#close"></use> </svg></span>
                            </div>`
                        } else {
                            let name = ''
                            if (key == 'price_min') {
                                name = 'From'
                            } else {
                                name = 'To'
                            }

                            labels += `<div class="label">
                            <div class="mr-5">${name + ' ' + currency + value}</div>
                            <span class="delete" data-delete="${key}"><svg class="icon"> <use xlink:href="#close"></use> </svg></span>
                            </div>`
                        }

                    }
                )
            }
        }
        return labels += price;
    }

    function labelEvents() {
        filterElement.querySelector('.filter__selected').querySelectorAll('.label').forEach(label => {
            if (!label) return;
            label.addEventListener('click', () => {
                let deleteItem = label.querySelector('.delete').dataset.delete.split('/');
                if (deleteItem.length > 1) {
                    filterObject[deleteItem[0]] = filterObject[deleteItem[0]].filter(el => el != deleteItem[1]);
                } else {
                    filterObject[deleteItem[0]] = [];
                    if (deleteItem[0] == 'from-to') {
                        filterObject['price_min'] = [];
                        filterObject['price_max'] = [];

                    }
                }
                label.remove();
                let controlParent = getElement(`[data-filter='${deleteItem[0]}']`)
                if (deleteItem[0] == 'from-to') {
                    controlParent = getElement('[data-price-all]')
                }
                if (controlParent.classList.contains('filter__items')) {
                    if (controlParent.dataset.priceAll) {
                        controlParent.querySelectorAll('input').forEach(input => {
                            input.parentElement.classList.remove('not-empty');
                            input.value = null;
                        })
                    } else {
                        let control = controlParent.querySelector(`[data-filter-control='${deleteItem[1]}']`)
                        control.classList.remove('selected')
                        if (control.classList.contains('active')) {
                            control.classList.remove('active');
                        }
                        if (!filterObject[deleteItem[0]].length) controlParent.classList.remove('selected')
                    }
                    if (isLogin) {
                        const info = controlParent.parentElement.previousElementSibling.querySelector('.info');
                        if (filterObject[deleteItem[0]].length > 0) {
                            if (info && !info.querySelector('.label')) {
                                info.innerHTML = `<div class="label label--black">Update</div>`
                            }
                        } else {
                            if (info && !info.querySelector('.icon')) {
                                info.innerHTML = `<div class="mr-5">Default</div>
                                    <svg class="icon">
                                        <use xlink:href="#info"></use>
                                    </svg>`
                            }
                        }
                        // if (info && !info.querySelector('.label')) {
                        //     info.innerHTML = `<div class="label label--black">Update</div>`
                        // }
                    }
                }
                if (controlParent.dataset.price) {
                    controlParent.parentElement.classList.remove('not-empty');
                    controlParent.value = null;
                }
                let isFiltered = noFiltered();
                if (isFiltered) {
                    renderFilterProducts(filteredProducts(filterObject));
                    filteredProductsCount(filterItems, filterObject, label)
                } else {
                    history.replaceState({pathname}, document.title, url)
                    renderAllProducts();
                    filteredProductsCount(filterItems, filterObject)
                }

            })
        })
    }

//FILTER LABELS FUNCTIONS END
    function renderProducts(filtered) {
        let fragment = '';
        filtered.forEach(filteredProduct => {
            const {
                productId,
                link,
                comments,
                discount,
                low_stock,
                title,
                currency,
                price,
                regularPrice
            } = filteredProduct;
            let labelDiscount = `<div class="label mr-5  label--discount "> <span data-product-discount="" class="mr-5">${discount}%</span> <span>Off</span></div>`;
            let labelStock = '<div class="label label--gray label--blur  text-color__white">Low Stock</div>';
            fragment += `<div class="catalog-item pos-r" data-catalog-item="${productId}">
                        <div class="catalog-item__preview flex --dir-col">
                            <div class="catalog-item__header mb-10">
                                <div class="reviews mb-5 flex --align-center --just-between ">
                                    <div class="stars flex --align-center"></div>
                                    <a href="${link}#reviews" class="flex --align-center"> <span data-revies="${comments.length}" class="mr-5">${comments.length}</span> <span>reviews</span> <span class="icon-arrow-right icon-14"></span> </a>
                                </div>
                                <div class="labels mb-15 flex 1">
                                    ${discount ? labelDiscount : ''}
                                    ${low_stock ? labelStock : ''}
                                </div>
                            </div>
                            <div class="catalog-item__gallery swiper__nav mb-10  pos-r" data-swiper="${productId}">
                                <div class="swiper-wrapper"></div>
                                <button class="prev slider__prev-catalog-item-id-${productId}">
                                    <span class="arrow arrow--left"> <span class="icon-arrow-right"></span> </span>
                                </button>
                                <button class=" next slider__next-catalog-item-id-${productId}">
                                    <span class="arrow "> <span class="icon-arrow-right"></span> </span>
                                </button>
                                <div class="swiper-pagination"></div>
                            </div>
                            <div class="catalog-item__title catalog-item--line border--bottom flex --dir-col">
                                <a href="${link}" data-href="" class="h2 fw-600 txt-no-underline text-color__black">${title}</a>
                                <div class="price mb-5 text-color__black--60 flex --align-end  ">
                                    <div data-price-new="${Math.ceil(price)}" class=" h2 fw-600 mr-10">${currency}${Math.ceil(price)}</div>
                                    <s data-price-old="${Math.ceil(regularPrice)}">${(regularPrice && price != regularPrice) ? currency + Math.ceil(regularPrice) : ''} </s>
                                </div>
                                <div class="flex --just-between --align-end  catalog-item__colors" data-attributes="">
                                    <div class="colors flex" data-select="pa_color"></div>
                                    <button class="ml-auto h2"> <span class="icon-wishlist icon-30"></span> </button>
                                </div>
                            </div>
                        </div>
                        <div class="catalog-item__descr ">
                            <div class=" catalog-item--line border--bottom labels flex">
                                <div class="label label--green" data-product-stock=""></div>
                            </div>
                            <div class="catalog-item__filters  border--bottom" data-attributes="configurations"></div>
                            <div class="catalog-item__btn">
                                <a href="${link}" class="btn btn--outline-black w-100" data-href=""> View </a></div>
                        </div>
                    </div>`
        })
        return fragment

    }

    function filteredProductsCount(filterItems, filteredObj, element = null) {
        filterItems.forEach(item => {
            const filterControls = item.querySelectorAll('[data-filter-control]');
            filterControls.forEach(control => {
                if (control.classList.contains('disabled')) control.classList.remove('disabled');
                let object = element ? JSON.parse(JSON.stringify(filteredObj)) : {};
                object[item.dataset.filter] = [control.dataset.filterControl];
                if (control.querySelector('[data-filter-items]')) {
                    control.querySelector('[data-filter-items]').innerText = filteredProducts(object).length ? filteredProducts(object).length : 0;
                    if (!filteredProducts(object).length) control.classList.add('disabled');
                }
            })
        })
    }

    function filteredProducts(filter = {}) {
        let filteredItems = JSON.parse(JSON.stringify(productsArray));
        let filterAttr = Object.keys({...filter}).filter(key => key.match(/pa/) && filter[key].length);
        if (filter['product_tag'] && filter['product_tag'].length) {
            filteredItems = filteredItems.filter(product => {
                const {product_tag} = product;
                return product_tag.find(({slug}) => filter['product_tag'].includes(slug));
            })
        }
        filteredItems = filteredItems.map(product => {
            let {attributes: {allAttributes, defaultAttributes}, variations} = product
            product.defaultItem = findVariationInProducts(defaultAttributes, product) ? findVariationInProducts(defaultAttributes, product) : product.variations[0];
            let cummerbundSize = false;
            if (allAttributes.find(el => Object.keys(el)[0] == 'pa_cummerbund-size')) cummerbundSize = true;
            if (cummerbundSize) {
                product.filteredVariations = isCummerbund(variations)
            }
            return product
        })

        if (filter.inStock) {
            filteredItems = filteredItems.filter((product) => {
                if (product.productId != 106664) {
                    let variations = product.filteredVariations && product.filteredVariations.length ? product.filteredVariations : product.variations;
                    product.filteredVariations = variations.filter(({in_stock}) => in_stock == filter.inStock)
                    if (product.filteredVariations.length) {
                        let findVariation = findVariationInFilteredVariations(product)
                        if (findVariation) {
                            product.defaultItem = findVariation;
                        } else {
                            product.filteredVariations.sort((a, b) => +a.price > +b.price ? 1 : -1)
                            product.defaultItem = product.filteredVariations[0];
                        }
                        return product;
                    }
                } else {
                    return product
                }
            })

        }
        if (+filter['price_min'] && +filter['price_max']) {
            filteredItems = filteredItems.filter(product => {
                if (product.filteredVariations) {
                    product.filteredVariations = product.filteredVariations.filter(({price}) => +price >= +filter['price_min'] && +price <= +filter['price_max']);
                } else {
                    product.filteredVariations = product.variations.filter(({price}) => +price >= +filter['price_min'] && +price <= +filter['price_max']);
                }
                if (product.filteredVariations.length) {
                    let findVariation = findVariationInFilteredVariations(product);
                    if (findVariation) {
                        product.defaultItem = findVariation;
                    } else {
                        product.filteredVariations.sort((a, b) => +a.price > +b.price ? 1 : -1);
                        product.defaultItem = product.filteredVariations[0];
                    }
                    return product
                }
                ;
            })
        } else if (+filter['price_min']) {
            filteredItems = filteredItems.filter(product => {
                if (product.filteredVariations) {
                    product.filteredVariations = product.filteredVariations.filter(({price}) => +price >= +filter['price_min']);
                } else {
                    product.filteredVariations = product.variations.filter(({price}) => +price >= +filter['price_min']);
                }
                if (product.filteredVariations.length) {
                    let findVariation = findVariationInFilteredVariations(product);
                    if (findVariation) {
                        product.defaultItem = findVariation;
                    } else {
                        product.filteredVariations.sort((a, b) => +a.price > +b.price ? 1 : -1);
                        product.defaultItem = product.filteredVariations[0];
                    }
                    return product
                }
            })
        } else if (+filter['price_max']) {
            filteredItems = filteredItems.filter(product => {
                if (product.filteredVariations) {
                    product.filteredVariations = product.filteredVariations.filter(({price}) => +price <= +filter['price_max']);
                } else {
                    product.filteredVariations = product.variations.filter(({price}) => +price <= +filter['price_max']);
                }
                if (product.filteredVariations.length) {
                    let findVariation = findVariationInFilteredVariations(product);
                    if (findVariation) {
                        product.defaultItem = findVariation;
                    } else {
                        product.filteredVariations.sort((a, b) => +a.price > +b.price ? 1 : -1);
                        product.defaultItem = product.filteredVariations[0];
                    }
                    return product
                }
                ;
            })
        }

        Object.keys({...filter}).forEach(key => {
            if (key.match(/pa/) && filter[key].length) {
                filteredItems = filteredItems.filter(product => {
                    const {attributes: {allAttributes}} = product;
                    const attribute = allAttributes.find(el => {
                        for (let k in el) {
                            if (k == key) return el
                        }
                    });
                    if (attribute) {
                        return attribute[key].values.find(({slug}) => filter[key].includes(slug));
                    }

                })
            }
        })

        if (filterAttr.length) {
            filteredItems = filteredItems.filter(product => {
                const {variations, attributes: {allAttributes, defaultAttributes}} = product;

                let attrDefault = JSON.parse(JSON.stringify(defaultAttributes))
                let object = {};
                let variationsFrom = [];
                for (let key in attrDefault) {
                    if (filter[key] && filter[key].length) {
                        attrDefault[key] = filter[key][filter[key].length - 1];
                    }
                }
                variations.forEach(variation => {
                    for (let attr of filterAttr) {
                        if (Object.keys(variation.attributes).includes(attr)) {
                            object[attr] = filter[attr]
                        }
                    }
                })
                if (product.filteredVariations) {
                    product.filteredVariations = product.filteredVariations.filter(variation => {
                        if (object && Object.keys({...object}).every(key => object[key].includes(variation.attributes[key]))) {
                            return product;
                        }
                    })
                }
                variationsFrom = product.filteredVariations ? [...product.filteredVariations] : [...variations];
                let findVariation = variationsFrom.find(variation => {
                    const {attributes} = variation;
                    if (attrDefault && Object.keys({...attrDefault}).every(key => attrDefault[key] == attributes[key])) {
                        product.defaultItem = variation;
                        return product;
                    }
                });
                if (findVariation) return product;


                let attrLength = [];
                for (let key of filterAttr) {
                    attrLength = [filter[key].length, ...attrLength]
                }

                function changeDefaultAttributes(object, i) {
                    for (let key of filterAttr) {
                        if (filter[key].length) {
                            if (!filter[key][filter[key].length - i]) {
                                return object[key] = filter[key][filter[key].length - i + 1]
                            }
                            object[key] = filter[key][filter[key].length - i];
                        }
                    }
                }

                //
                //
                for (let i = 1; i <= Math.max(...attrLength); i++) {
                    changeDefaultAttributes(attrDefault, i)

                    findVariation = variationsFrom.find(el => attrDefault && Object.keys({...attrDefault}).every(key => attrDefault[key] == el.attributes[key]));

                    if (findVariation) {
                        product.defaultItem = findVariation;
                        break;
                    }


                }
                if (findVariation) return product;
                if (variationsFrom.length) {
                    product.defaultItem = variationsFrom[0];
                    return product;
                }
            })
        }

        if (filter.sort) {
            switch (filter.sort) {
                case 'rating':
                    filteredItems = filteredItems.sort((a, b) => +a.rating.rating < +b.rating.rating ? 1 : -1)
                    break;
                case 'ASC':
                    filteredItems = filteredItems.sort((a, b) => +a.defaultItem.price > +b.defaultItem.price ? 1 : -1)
                    break;
                case 'DESC':
                    filteredItems = filteredItems.sort((a, b) => +a.defaultItem.price < +b.defaultItem.price ? 1 : -1)
                    break;
            }
        }
        return filteredItems;
    }
}

function findVariationInFilteredVariations(product) {
    return product.filteredVariations.find(variation => {
        const {attributes} = variation;
        if (product.attributes.defaultAttributes && Object.keys({...product.attributes.defaultAttributes}).every(key => product.attributes.defaultAttributes[key] == attributes[key])) {
            return variation
        }

    })
}


function isCummerbund(array) {
    return array.filter(({attributes}) => attributes['pa_cummerbund-size'] == attributes['pa_size'])
}

export {isCummerbund}
